<template>
  <ValidationProvider
    :ref="name"
    :name="name"
    :vid="name"
    :rules="rules"
    :mode="validationMode"
    slim
    v-slot="{ errors }"
  >
    <v-select
      :items="options"
      v-model="model"
      :name="name"
      :label="`${label} ${requiredHint}`"
      :placeholder="placeholder"
      :error-messages="errors[0]"
      :multiple="multiple"
      v-bind="{ ...select }"
      :style="customStyle"
    />
  </ValidationProvider>
</template>

<script>
import _ from "lodash";
import { getFieldRules } from "@/utils/auth/validation";

export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Array],
      default: ""
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    name() {
      return _.get(this.component, "name", "");
    },
    label() {
      return _.get(this.component, "label", "");
    },
    placeholder() {
      return _.get(this.component, "placeholder", "");
    },
    requiredHint() {
      return _.get(this.component, "required", false) ? "*" : "";
    },
    rules() {
      return getFieldRules(this.component);
    },
    validationMode() {
      return _.get(this.component, "validationMode", "eager");
    },
    // https://vuetifyjs.com/en/api/v-select/
    select() {
      return _.get(this.component, "props.select", {});
    },
    customStyle() {
      return _.get(this.component, "props.style", {});
    }
  },
  created() {
    this.$emit("field-registered", this.name);
  }
};
</script>

<style lang="scss" scoped></style>
